import React from "react";

// material components
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";

// custom components
import GlobalTableHead from "../global/Table/GlobalTableHead";
import SearchableTable from "../global/Search/SearchableTable";

// constants
import {
    ROWS_PER_PAGE_LABEL,
 ORDER_PLANNING_TABLE_HEAD_CELLS,
} from './constants';
import { ASC, DESC } from "../global/constants";
import { DEFAULT_SORT_BY_HEAD_CELL } from "./constants";
import { IconButton, TableBody, TablePagination } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";


// styling
import EditIcon from "@material-ui/icons/Edit";
import CustomTableHeader from "../global/Table/CustomTableHeader";
import LocationSelectBox from "../global/subcomponents/locationSelectBox/LocationSelectBox";
import TwoStepDelete from '../global/subcomponents/twoStepDelete/TwoStepDelete';

class OrderPlanningTable extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            order: DESC,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            isSearch: false,
            searchValue: '',
            searchRows: 0,
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.searchText !== this.props.searchText || this.state.searchValue !== this.props.searchText) {
            this.initializeSearchText()
        }
    }

    initializeSearchText = () => {
        this.setState({ searchValue: this.props.searchText })
    }

    onSearchValueChange = (e) => {
        this.setState({
            isSearch: e.target.value.length > 0,
            searchValue: e.target.value
        });
        this.props.setPage(0)
        this.props.handleSearchChange(e)
    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === ASC;
        this.setState({
            order: isAsc ? DESC : ASC,
            orderBy: property,
        });
    };

    getDisplayed = (rows) => {
        if (!rows)
            return [];
        return [...rows.slice(this.props.page * this.props.rowsPerPage, this.props.page * this.props.rowsPerPage + this.props.rowsPerPage)];
    }

    handleChangePage = (event, newPage) => {
        this.props.setPage(newPage)
    };

    handleChangeRowsPerPage = (event) => {
        this.props.setRowsPerPage(event.target.value)
        this.props.setPage(0)
    };



    filterByLocation = (rows) => {
        return rows.filter((row) => {return row.location?.shipAddressId === this.props.selectedLocation})
    }


    render() {
        return (
            <>
                <CustomTableHeader
                    searchText={this.props.searchText}
                    onSearchValueChange={this.onSearchValueChange}
                    // customFilterField={
                    //
                    // }
                    pagination={
                        <TablePagination
                            className="table-pagination"
                            labelRowsPerPage={ROWS_PER_PAGE_LABEL}
                            rowsPerPageOptions={[5, 25, 50, 100, {value: this.props.rows.length, label: "All"} ]}
                            count={!this.props.rows ? 0 : this.filterBySearch(this.props.rows).length}
                            rowsPerPage={this.props.rowsPerPage}
                            page={this.props.page}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    }
                    locationField={<LocationSelectBox/>}
                />

                <TableContainer>
                    <Table
                        size='medium'
                    >
                        <GlobalTableHead
                            isCreatePurchaseOrderTable={false}
                            isShipmentTable={false}
                            headCells={ORDER_PLANNING_TABLE_HEAD_CELLS}
                            order={this.state.order}
                            orderBy={this.state.orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={!this.props.rows ? 0 : this.props.rows.length}
                        />
                        <TableBody>
                            {this.getDisplayed(this.stableSort(this.filterByLocation(this.filterBySearch((this.props.rows))), this.getComparator(this.state.order, this.state.orderBy))).map((row, index) => {

                                return (
                                    <TableRow key={index} hover onDoubleClick={() => this.props.handleDoubleClick(row)}>
                                        <TableCell>
                                            <IconButton onClick={() => this.props.handleDoubleClick(row)}>
                                                 <EditIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell className='cellPadding'>
                                            {row.planName}
                                        </TableCell>

                                     <TwoStepDelete
                                        rowId={row.orderPlanningId}
                                        handleDelete={(rowIdToDelete) => this.props.deleteOrderPlanning({orderPlanningId: rowIdToDelete})}
                                        deleteId={this.state.deleteId}
                                        setDeleteId={(newDeleteId) => this.setState({deleteId: newDeleteId})}
                                    />

                                    </TableRow>
                                );

                            })
                            }
                        </TableBody>

                    </Table>
                </TableContainer>
            </>
        );
    }

}

export default OrderPlanningTable;